import React, {useMemo, useState, useEffect} from 'react';
import {useSelector} from 'react-redux';

import {getSeoAboutDescription} from '@stencil/hotels-utils/src/details/seo-about-desc';
import {
  hotelDetailsSelector,
  ugcSummaryGISelector,
} from '@stencil/hotels-cg-reducer/src/details/selectors';
import {countrySelectorFn} from '@stencil/hotels-common-reducer/src/selectors';

import AboutProperties from '../../../../../stories/components/hotels/DetailsPageUnif/AboutProperties/AboutProperties';

const FollowUpContent = () => {
  const ugcSummaryGIData = useSelector(ugcSummaryGISelector);
  const staticHotelDetailsData = useSelector(hotelDetailsSelector);
  const countryCode = useSelector(countrySelectorFn);
  const propertyName = staticHotelDetailsData?.name;
  const shortDescSeo = staticHotelDetailsData?.shortDescSeo;

  const seoDesc = useMemo(
    () =>
      getSeoAboutDescription(
        propertyName,
        staticHotelDetailsData?.propertyType,
        ugcSummaryGIData,
        countryCode,
      ),
    [staticHotelDetailsData, ugcSummaryGIData, countryCode],
  );

  if (!seoDesc && !shortDescSeo) {
    return null;
  }

  return (
    <AboutProperties
      text={`What Guests Love About ${propertyName}`}
      desc={seoDesc}
      shortDescSeo={shortDescSeo}
    />
  );
};

export default FollowUpContent;
